const Footer = () => {
  return (
    <div className="footer">
      <div className="cta-wrapper ux-get-three-quotes mht-general-store-item">
        <a
          className="cta-base cta-primary trigger-quote-modal"
          href="https://myhometurf.com.au/get-quotes-now/"
          target="__blank"
        >
          Get 3 Quotes Now
        </a>
      </div>
      <div className="menu-footer-menu-container">
        <ul id="footer-menu" className="menu">
          <li
            id="menu-item-854"
            className="mht-general-store-item ux-menu-find-yout-turf menu-item menu-item-type-post_type menu-item-object-page menu-item-854"
          >
            <a href="https://myhometurf.com.au/find-your-turf/">
              Find Your Turf
            </a>
          </li>
          <li
            id="menu-item-853"
            className="mht-general-store-item ux-menu-find-turf-suppier menu-item menu-item-type-post_type menu-item-object-page menu-item-853"
          >
            <a href="https://myhometurf.com.au/find-a-turf-supplier/">
              Find A Turf Supplier
            </a>
          </li>
          <li
            id="menu-item-852"
            className="mht-general-store-item menu-item menu-item-type-post_type menu-item-object-page menu-item-852"
          >
            <a href="https://myhometurf.com.au/lawn-tips/">Lawn Tips</a>
          </li>
          <li
            id="menu-item-851"
            className="mht-general-store-item menu-item menu-item-type-post_type menu-item-object-page menu-item-851"
          >
            <a href="https://myhometurf.com.au/about-us/">About Us</a>
          </li>
          <li
            id="menu-item-12429"
            className="mht-general-store-item menu-item menu-item-type-post_type menu-item-object-page menu-item-12429"
          >
            <a href="https://myhometurf.com.au/turf-suppliers/">
              Turf Suppliers Australia
            </a>
          </li>
          <li
            id="menu-item-15397"
            className="mht-general-store-item menu-item menu-item-type-post_type menu-item-object-page menu-item-15397"
          >
            <a href="https://myhometurf.com.au/website-terms/">
              Website Terms
            </a>
          </li>
          <li
            id="menu-item-15398"
            className="mht-general-store-item menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-15398"
          >
            <a
              rel="privacy-policy"
              href="https://myhometurf.com.au/privacy-policy/"
            >
              Privacy Policy
            </a>
          </li>
          <li
            id="menu-item-15416"
            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-15416"
          >
            <a href="https://myhometurf.com.au/customer-terms/">
              Customer Terms
            </a>
          </li>
        </ul>
      </div>
      <a
        rel="home"
        href="https://myhometurf.com.au/"
        title="My Home Turf"
        itemProp="url"
        className="text-decoration-none"
      >
        <div className="footer-copy">
          © 2025 myhomeTURF. All Rights Reserved.
        </div>
      </a>
      <p className="reference-line" style={{ fontSize: "10px", color: "#ccc", textAlign: "center" }}>
        By{" "}
        <a
          href="https://wpcare.io"
          target="_blank"
          rel="noreferrer"
          style={{ color: "#bbb", textDecoration: "none" }}
        >
          WP Care
        </a>
      </p>
      <ul className="bottom-socials">
        <li>
          <a href="https://www.facebook.com/myhometurf/" target="_new">
            <img
              src="https://myhometurf.com.au/wp-content/themes/myhometurf/img/facebook.png"
              alt=""
            />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/myhometurf/" target="_new">
            <img
              src="https://myhometurf.com.au/wp-content/themes/myhometurf/img/instagram.png"
              alt=""
            />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Footer;
